export default class EnvProvider {
    constructor() {
        this.REACT_APP_NETWORK_ENV = process.env.REACT_APP_NETWORK_ENV
        this.REACT_APP_DEV_ENV = process.env.REACT_APP_DEV_ENV
        this.NODE_ENV = process.env.NODE_ENV
    }
}